// This file is necessary to MFEs to work with Angular

import('./bootstrap').catch((err) => console.error(err));
